import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useContent } from "../../lib/content";
import { eventsFor, fireEvent, matchesTarget, matchesUrl, metaSend } from "../../lib/tracking";

const firePageEvents = (tracking) => {
  eventsFor(tracking, "pagina").forEach((ev) => {
    if (matchesUrl(ev)) fireEvent(ev, { page: window.location.pathname });
  });
};

export const TrackingManager = () => {
  const { tracking } = useContent();
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    const onClick = (e) => {
      eventsFor(tracking, "click").forEach((ev) => {
        if (matchesUrl(ev) && matchesTarget(e.target, ev.target)) fireEvent(ev, { page: window.location.pathname });
      });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [tracking]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!first.current) {
        metaSend("PageView");
        if (typeof window.gtag === "function") window.gtag("event", "page_view", { page_path: pathname });
      }
      first.current = false;
      firePageEvents(tracking);
    }, 600);
    return () => clearTimeout(t);
  }, [pathname, tracking]);

  useEffect(() => {
    let t;
    const onConsent = () => { t = setTimeout(() => firePageEvents(tracking), 400); };
    window.addEventListener("consent-changed", onConsent);
    return () => { clearTimeout(t); window.removeEventListener("consent-changed", onConsent); };
  }, [tracking]);

  return null;
};
